export abstract class DateService {
  abstract now(): string;
  abstract today(): string;
}
